import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    deepStringFind,
    errorRedirect,
    inject,
    ModalHandle,
    NothingHere,
    PartStateAlert,
    SubTopBar,
    Title,
    toArray,
    Tooltip,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';
import { RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, ButtonGroup, Input } from 'reactstrap';
import { CreatePart } from './CreatePart';
import { PartsListItem } from './PartsListItem';
import { PartsStore } from './PartsStore';

export interface IPartsListParams {
    partDefinitionGuid: string;
}
export interface IPartsListProps extends RouteComponentProps<IPartsListParams> {}

@autoinject
@observer
export class PartsList extends React.Component<IPartsListProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.partsStore.loadAllForPartDefinitionAsync(this.props.match.params.partDefinitionGuid);
        } catch (e: any) {
            errorRedirect(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid">
                <Title>Parts</Title>

                <SubTopBar>
                    <a className="btn btn-primary" onClick={this.openPartModal}>
                        Create Part
                    </a>

                    <div className="mx-2 border" />

                    <Input
                        type="text"
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                        className="mw-450"
                        placeholder="Search Parts..."
                    />
                </SubTopBar>

                <div className="row">
                    <div className="col-12 px-0">
                        <table className="table table-striped w-100 h-100">
                            <thead>
                                <tr>
                                    <th>Serial</th>

                                    <th>Description</th>

                                    <th>Model</th>

                                    <th>Children</th>

                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.parts?.map(p => (
                                    <PartsListItem key={p.partGuid} part={p} />
                                ))}
                            </tbody>
                        </table>

                        <NothingHere empty={this.parts.length <= 0} icon={<BsCardHeading />} loading={this.loading} />

                        <CreatePart
                            modalHandle={this.modalHandle}
                            partDefinitionGuid={this.props.match.params.partDefinitionGuid}
                        />
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private async onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @computed
    private get parts() {
        let parts = toArray(this.partsStore.parts);

        if (this.searchValue) {
            parts = parts!.filter(p => {
                return deepStringFind(p, this.searchValue);
            });
        }

        return parts;
    }

    @bind
    private openPartModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.modalHandle.open();
    }

    @inject
    private readonly partsStore!: PartsStore;
    private modalHandle = new ModalHandle();
    @observable private searchValue: string = '';
    @observable private loading = false;
}
